import axios from "axios";

const BASE_URL =
  process.env.REACT_APP_API_URL ||
  "https://amplify-user-data-management.wegolab.net";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    switch (error.code) {
      case "ERR_NETWORK":
        alert("네트워크 오류 발생");
        break;
      case "ERR_BAD_REQUEST":
      case "ERR_BAD_RESPONSE":
        if (error.response.data?.message) {
          alert(error.response.data?.message);
        } else {
          alert("요청 형식이 잘못되었습니다.");
        }
        break;

      default:
        break;
    }

    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        console.warn("로그인이 필요합니다.");
      } else if (status === 500) {
        console.error("서버 에러 발생");
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
